export default __webpack_public_path__ + "logo-cow-gate-happy-kids.fe41210.png";